export default __webpack_public_path__ + "static/media/patroni-01.b3d3f828.png";